import styled, { keyframes } from 'styled-components'

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const LoaderDisplay = styled.div`
  padding: 10px;
  border: 6px solid red;
  border-bottom-color: transparent;
  border-radius: 22px;
  animation: ${rotate} 1s infinite linear;
  height: 0;
  width: 0;
`
const LoaderWrap = styled.div`
display:flex;
justify-content:center;
`

export const Loader = ()=>{
return ( <LoaderWrap> 
            <LoaderDisplay/>
        </LoaderWrap>)

}